export const FONT_WEIGHTS = {
  DEFAULT: 400,
  SLIGHTLY_BOLD: 500,
  BOLD: 700,
};

export const COLORS = {
  WHITE: "#FFFFFF",
  BLACK: "#000000",
};
